import { API_URL_VERSION } from "../constants/environment";
import api from "./api";
import { toSearchFilter } from "../utils";

export const ENDPOINT_DARV = API_URL_VERSION + 'v2/gen-docs/darv-generic';
export const ENDPOINT_COLLECTIONS_LIST = API_URL_VERSION + 'v2/gen-docs';

export const STATUS_LIST = [
    {
        status: "Pendente",
        id: "PENDENTE"
    },
    {
        status: "Bloqueado",
        id: "BLOQUEADO"
    },
    {
        status: "Regularizado",
        id: "REGULARIZADO"
    }
];

export const collectionsService = {
    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_DARV, data, {
                headers: {
                    "Content-Type": "application/json",
                },
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "digital-collections.messages.errors.create";
        }
    },

    list: async (params = {}) => {
        try {
            const response = await api.post(ENDPOINT_COLLECTIONS_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "digital-collections.messages.errors.list";
        }
    }
};
